import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import {TypeaheadBase} from '../../../common/typeahead/typeahead-base';

@Component({
  selector: 'app-item-select',
  templateUrl: './item-select.component.html',
  styleUrls: ['./item-select.component.css'],
  standalone: false
})
export class ItemSelectComponent extends TypeaheadBase implements OnInit {

  @Input() vm: any;

  @Output() updateInventoryItemEmit = new EventEmitter<string>();
  @Output() testItemEmit = new EventEmitter<string>();
  @Output() selectItemModalNewEmit = new EventEmitter<string>();

  constructor() {
    super();
  }

  itemTypeaheadSearch = (text$: any) => this.typeaheadSearch(text$, () => this.vm?.inventoryItemName, 10);

  ngOnInit() {
  }

  testItem() {
    this.testItemEmit.emit();
  }

  onItemBlur(typeahead: any) {
    if (typeahead?.isPopupOpen?.()) {
      return;
    }
    this.testItem();
  }

  updateInventoryItem() {
    this.updateInventoryItemEmit.emit();
  }

  selectItemModalNew(itemId) {
    this.selectItemModalNewEmit.emit(itemId);
  }

}
